export const capitalizeFirstLetter = (str: string) =>
	str.charAt(0).toUpperCase() + str.slice(1)

export const toCamelCase = (str: string) =>
	str.replaceAll(/([-_][a-z])/gi, $1 =>
		$1.toUpperCase().replace('-', '').replace('_', '')
	)

const isCamelCase = (str: string) => /[A-Z]/.test(str)

const isSnakeCase = (str: string) => str.includes('_')

// Regex from https://stackoverflow.com/a/1373724/4482064
const emailRegex =
	/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/

const isValidEmail = (email: string): boolean => emailRegex.test(email)

interface ITruncateStringOptions {
	addEllipsis?: boolean
}

export const truncateString = (
	str: unknown,
	max = 50,
	{ addEllipsis = true }: ITruncateStringOptions = {}
) => {
	if (typeof str === 'string') {
		return str.length > max
			? `${str.slice(0, max).trim()}${addEllipsis ? '...' : ''}`
			: str
	}
	return str
}

interface IToSentenceCaseOptions {
	separator?: string
}

//snake_case -> Snake case
//camelCase -> Camel case
export const toSentenceCase = (
	_str: string,
	{ separator }: IToSentenceCaseOptions = {}
) => {
	let str = _str
	if (separator) {
		str = str.split(separator).join(' ')
	} else if (isCamelCase(str)) {
		str = str.replaceAll(/([a-z](?=[A-Z]))/g, '$1 ').toLocaleLowerCase()
	} else if (isSnakeCase(str)) {
		str = str.split('_').join(' ')
	}

	return capitalizeFirstLetter(str)
}

const stringToBool = (value?: string) =>
	value === undefined ? undefined : value === 'true'

function boolToString(value?: boolean): 'true' | 'false' | undefined
function boolToString(
	value: boolean | undefined,
	defaultValue: string
): 'true' | 'false' | string
function boolToString(
	value?: boolean,
	defaultValue?: string
): 'true' | 'false' | string | undefined {
	return value === undefined ? defaultValue : value ? 'true' : 'false'
}

export { boolToString, isValidEmail, stringToBool }
